exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".foldcontent-panel{box-sizing:border-box;position:relative;width:700px;margin:20px auto;padding:30px;color:#666;line-height:2.5;border:1px solid #eee;box-shadow:5px 6px 5px #ccc}.all-content{display:none}.unfold{position:absolute;border-radius:5px;cursor:pointer}.slide-btn{animation:foldSlide .1s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}@-webkit-keyframes foldSlide{0%{bottom:0}to{bottom:15px}}@keyframes foldSlide{0%{bottom:0}to{bottom:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/style.css
// module id = 2
// module chunks = 0